class RecommendedProducts extends HTMLElement {
  constructor() {
    super()

    this.productId = this.dataset.productId
    this.carousel = this.querySelector('.recommended-products__carousel')
  }

  connectedCallback() {
    this.getRecommendations()
  }

  getRecommendations() {
    fetch(window.Shopify.routes.root + `recommendations/products?product_id=${this.productId}&section_id=recommended-products-cards`)
      .then(response => response.text())
      .then(data => {
        this.render(data)
      })
  }

  render(markup) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(markup, 'text/html')
    const products = doc.querySelector('#shopify-section-recommended-products-cards').innerHTML
    this.carousel.innerHTML = products

    Object.assign(this.carousel, {
      pagination: {
        el: document.querySelector(`.recommended-products__carousel-dots`),
        clickable: true
      },
      slidesPerView: 1.2,
      spaceBetween: 12,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
      roundLenghts: true,
      mousewheel: {
        enabled: true,
        forceToAxis:true,
      },
      breakpoints: {
        520: {
          slidesPerView: 'auto',
        },
        767: {
          slidesPerView: 'auto',
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
        },
        1440: {
          slidesPerView: 'auto',
          spaceBetween: 24,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
        }
      },
      on: {
        init: (swiper) => {
          swiper.el.style.overflow = 'visible';
        }
      }
    });

    this.carousel.initialize()
  }


}

if (!customElements.get('recommended-products'))
  customElements.define('recommended-products', RecommendedProducts)